import React from 'react';
import data from '../data/ProjectsArchive.json'

const ProjectArchive = () => {
    return (
        <section className='project-archive'>
            <div className='name'>All Projects</div>
            <div className="table header ">
                <div className="div1 year">Year</div>
                <div className="div2 project">Project</div>
                <div className="div3 made">Made at</div>
                <div className="div4 technology">Built with</div>
                <div className="div5 link">Link</div>
            </div>
                {data.map((items) => {
                    return (
                        <div className="table row" key={items.id}>
                            <div className="div1 year">{items.year}</div>

                            <div className="div2 project"><a href={items.linkUrl} target='_blank' rel="noreferrer">
                                {items.projectName}</a>
                                </div>

                            <div className="div3 made">{items.madeAt}</div>
                            <div className="div4 technology">
                                {items.technology.map((tag, index)=>{return(
                                    <div className="tag" key={index}>{tag}</div>
                                )})}

                            </div>
                            <div className="div5 link"><a href={items.linkUrl} target='_blank' rel="noreferrer">{items.link}</a></div>
                        </div>
                    )
                })}
        </section>

    );
};

export default ProjectArchive;